module.exports = __webpack_public_path__ + "media/media/about/young_and_Innovative-d9f199f7e0e69a2dd3844b51f8e3204e.png";